import axios from 'axios'
import * as rax from 'retry-axios'
import _ from 'lodash'

export default function (sevenJwt, netent) {
  if (_.isEmpty(sevenJwt)) throw new Error('Parameter [sevenJwt] cannot be empty')
  if (_.isEmpty(netent)) throw new Error('Parameter [netent] cannot be empty')

  let isAnonymousSession = false
  const baseUrl = process.env.VUE_APP_NETENT_REST_WALLET_BASE_URL
  if (sevenJwt && sevenJwt !== 'undefined') {
    axios.defaults.headers.common.Authorization = `Bearer ${sevenJwt}`
  } else {
    isAnonymousSession = true
  }

  rax.attach()
  const raxConfig = {
    httpMethodsToRetry: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'COPY', 'HEAD', 'OPTIONS', 'LINK', 'UNLINK', 'PURGE', 'LOCK', 'UNLOCK', 'PROPFIND', 'VIEW'],
    retry: 1,
    noResponseRetries: 1,
    backoffType: 'static',
    retryDelay: 2000
  }

  // Interval declarations
  let validSessionInterval,
    aliveInterval,
    validSessionIntervalIsRunning,
    aliveIntervalIsRunning

  async function establishSession (
    requestPayload,
    sessionData,
    netentLaunchCallback,
    sessionRefreshFailureCallback
  ) {
    if (_.isEmpty(requestPayload)) throw new TypeError('Parameter [requestPaload] cannot be empty')
    if (!_.isObjectLike(requestPayload)) throw new TypeError('Parameter [requestPayload] must be an object or an array')
    if (!_.isFunction(netentLaunchCallback)) throw new TypeError('Parameter [netentLaunchCallback] must be a function')
    if (!_.isFunction(sessionRefreshFailureCallback)) throw new TypeError('Parameter [sessionRefreshFailureCallback] must be a function')

    // We can't establish a session if the userUuid is missing
    if (_.isEmpty(requestPayload.userUuid)) {
      isAnonymousSession = true
    }

    // Establish session with NSoft - NetEnt REST Wallet backend
    let data = {}
    if (!isAnonymousSession) {
      const result = await axios({
        baseURL: baseUrl,
        url: 'getSession',
        method: 'POST',
        raxConfig,
        data: requestPayload
      })
      data = result.data

      if (data.demo) {
        data.sessionId = `DEMO-${Math.floor(Math.random() * 0xFFFFFFFF)}`
      }
    } else {
      // Since we wont be fetching a session, we're going to hardcode these values and hope for the best
      data.demo = true
      data.sessionId = `DEMO-${Math.floor(Math.random() * 0xFFFFFFFF)}`
      // TODO: Bootstrap request
      data.linkStatic = process.env.NODE_ENV === 'production' ? 'https://balkanbet-static.casinomodule.com' : 'https://balkanbet-static-test.casinomodule.com'
      data.linkGame = process.env.NODE_ENV === 'production' ? 'https://balkanbet-game.casinomodule.com' : 'https://balkanbet-game-test.casinomodule.com'
    }

    // NetEnt Game Inclusion - Configuration
    const netentConfig = {
      gameId: sessionData.gameId,
      staticServer: data.linkStatic,
      gameServer: data.linkGame,
      sessionId: data.sessionId,
      targetElement: 'netEntGame',
      walletMode: 'seamlesswallet',
      language: requestPayload.language,
      enforceRatio: true
    }

    // TODO: Investigate SevenWeb isMobile flag
    // If we're running a mobile game, we must set additional properties
    if (!sessionData.gameId.includes('not_mobile')) {
      netentConfig.enforceRatio = false
      netentConfig.width = '100%'
      netentConfig.height = '100%'
      netentConfig.allowHtmlEmbedFullScreen = true
      netentConfig.iframeSandbox = 'allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation allow-same-origin allow-forms allow-pointer-lock'
      netentConfig.applicationType = 'browser'
      netentConfig.launchType = 'iframe'
      netentConfig.casinoBrand = 'balkanbet'
      netentConfig.fullScreen = true
      netentConfig.lobbyURL = '#'
    }

    netent.launch(netentConfig, function (netEntExtend) {
      netentLaunchCallback(netEntExtend)

      // Don't refresh session in anonymous mode
      if (isAnonymousSession) {
        return
      }

      /* INTERVAL 1 (every 25 sec) */
      validSessionIntervalIsRunning = true
      aliveInterval = setInterval(async function () {
        const isUserSessionAliveResult = await axios({
          baseURL: baseUrl,
          url: 'isUserSessionAlive',
          method: 'POST',
          data: {
            tenantUuid: sessionData.tenantUuid,
            sessionId: data.sessionId,
            language: sessionData.language,
            userUuid: sessionData.userUuid
          }
        })
        isUserSessionAliveResult.data.responseMessage === 'true'
          ? validSessionIntervalIsRunning = true
          : validSessionIntervalIsRunning = false

        if (!validSessionIntervalIsRunning) {
          clearInterval(aliveInterval)
          sessionRefreshFailureCallback('isUserSessionAlive')
        }
      }, 25000)

      /* INTERVAL 2 (every 2 min) */
      aliveIntervalIsRunning = true
      validSessionInterval = setInterval(async function () {
        const refreshSessionResult = await axios({
          baseURL: baseUrl,
          url: 'refreshSession',
          method: 'POST',
          data: {
            tenantUuid: sessionData.tenantUuid,
            sessionId: data.sessionId,
            language: sessionData.language,
            userUuid: sessionData.userUuid
          }
        })
        refreshSessionResult.status === 200
          ? aliveIntervalIsRunning = true
          : aliveIntervalIsRunning = false

        if (!aliveIntervalIsRunning) {
          clearInterval(validSessionInterval)
          sessionRefreshFailureCallback('refreshSession')
        }
      }, 120000)
    },
    console.error)

    return { isDemo: data.demo || isAnonymousSession }
  }

  function closeSession () {
    console.log('Closing Netent session')
    clearInterval(validSessionInterval)
    clearInterval(aliveInterval)
  }

  return { establishSession, closeSession }
};
